import {
  EgibObject,
  EnablementType,
  LawPersonSearch,
  MapObject,
  MapState,
} from '@gk/gk-modules';
import { FSPNewRequestFormValue } from '../../modules/free-services-portal/services/new-request-form/new-request-form.model';
import { AuthorizedPersonToRegistryView } from '../authorized-person-to-registry-view/authorized-person-to-registry-view.model';
import { ConnectionAndNetworkFormGroupContent } from '../connection-and-network/connection-and-network.model';
import { NewDesignerRequestFormModel } from '../new-designer-request/new-designer-request.model';
export enum WorkspaceStateId {
  DesignerNewRequestForm = 'projektant',
  PrzpNewRequestForm = 'przp',
  GrantingRightsNewRequestForm = 'wn_nadanie_upr',
  PresentationCommentsLandBuildingRegistryProjectNewCommentsForm = 'wn_uwagi_do_wylozenia',
  GeodeticAndCartographicServiceDataRequestNewRequestForm = 'wn_dane_dla_sluzby_geo',
  LandAndBuildingRegisterDataUpdateUponEntitiesRequestForm = 'wn_aktualizacja_egib_przez_podmiot',
  PermanentManagementFeeDiscountDecisionGrantingRequestForm = 'wn_bonifikata_opl_trwaly_zarzad',
  PrzpNewAgreementForm = 'przp_porozumienie',
  LandAndBuildingRegisterDataChangesNotificationRequestForm = 'wn_zmiana_danych_egib',
  SoilClassificationOfLandNewCarryOutRequestForm = 'wn_gleboznawcza_klasyfikacja_grun',
  TreesAndShrubsFellingRequestForm = 'wn_zezwolenie_wycinka_drzew',
  OwnershipConversionFeeCalculationRequestForm = 'wn_naliczenie_oplaty_przeksztalcenie_wieczystego_we_wlasnosc',
  SupplementaryParcelPurchaseRequestForm = 'wn_zakup_dzialki_uzupelniajacej',
  PlanningActCommentsRequestForm = 'wn_uwagi_proj_akt_plan_przestrz',
  PlanningActCreationAmendmentRequestForm = 'wn_zmiana_sporzadzenie_akt_plan_przestrz',
  PlanningActProjectRequestForm = 'wn_do_proj_akt_plan_przestrz',
  PropertyLeaseRequestForm = 'wn_wydzierzawienie_nieruchomosci_komunalnej_lub_sp',
  PropertyOccupancyTechnicalInstallationConsentRequestForm = 'wn_zajecie_gminy_lub_sp_do_wykonania_urzadzen_technicznych',
  ExcludingLandFromAgriculturalProductionStageFirstRequestForm = 'wn_wyl_gr_z_prod_rolnej',
  TreesAndShrubsFallNotificationForm = 'wn_zgloszenie_zlomu',
  TreesAndShrubsFellingWithDecisionRequestForm = 'wn_zezwolenie_wycinka_z_wydaniem_decyzji',
  TreesAndShrubsRemovalNotificationForm = 'wn_zgloszenie_zamiaru_usuniecia_krzewu_lub_drzewa',
  SimplifiedForestManagementPlanRequestComponent = 'wn_objecie_dzialki_upul',
  MonumentConservationGrantRequestForm = 'wn_dotacje_konserwacja_zabytk',
  MonumentInstallationRequestForm = 'wn_wydanie_decyzji_konserwatora_zabytkow',
  InstallationNotificationWithoutEmissionPermitForm = 'wn_zgloszenie_instalacji_emisyjnej',
  HouseholdSewageTreatmentNotificationForm = 'wn_zgloszenie_eksploatacji_oczyszczalni',
}

export enum BsMessageType {
  Info = 'info',
  Success = 'success',
  Danger = 'danger',
}

export enum WorkspaceStateDraftVersion {
  DesignerNewRequestFormVersion = '2',
  PrzpNewRequestFormVersion = '6',
  GrantingRightsNewRequestFormVersion = '4',
  PresentationCommentsLandBuildingRegistryProjectNewCommentsFormVersion = '1',
  GeodeticAndCartographicServiceDataRequestNewRequestFormVersion = '1',
  LandAndBuildingRegisterDataUpdateUponEntitiesRequestFormVersion = '2',
  PermanentManagementFeeDiscountDecisionGrantingRequestFormVersion = '1',
  LandAndBuildingRegisterDataChangesNotificationRequestFormVersion = '1',
  SoilClassificationOfLandNewCarryOutRequestFormVersion = '1',
  TreesAndShrubsFellingRequestFormVersion = '2',
  OwnershipConversionFeeCalculationRequestFormVersion = '2',
  SupplementaryParcelPurchaseRequestFormVersion = '1',
  PlanningActCommentsRequestFormVersion = '1',
  PlanningActCreationAmendmentRequestFormVersion = '1',
  PlanningActProjectRequestFormVersion = '1',
  PropertyLeaseRequestFormVersion = '1',
  PropertyOccupancyTechnicalInstallationConsentRequestFormVersion = '1',
  ExcludingLandFromAgriculturalProductionStageFirstRequestFormVersion = '1',
  TreesAndShrubsFallNotificationFormVersion = '1',
  TreesAndShrubsFellingWithDecisionRequestFormVersion = '1',
  TreesAndShrubsRemovalNotificationFormVersion = '1',
  SimplifiedForestManagementPlanRequestComponentVersion = '1',
  MonumentConservationGrantRequestFormVersion = '1',
  MonumentInstallationRequestFormVersion = '1',
  InstallationNotificationWithoutEmissionPermitFormVersion = '1',
  HouseholdSewageTreatmentNotificationFormVersion = '1',
}

export type StringifiedDocFile = string | undefined;

export interface WorkspaceState {
  draftVersion?: WorkspaceStateDraftVersion;
}

export interface DesignerNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: NewDesignerRequestFormModel;
  chosenParcels: EgibObject[];
  issueRanges: MapObject[];
  chosenConnectionsAndNetworksGroups: ConnectionAndNetworkFormGroupContent[];
  lawPersons: LawPersonSearch[];
}

export interface PrzpNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: FSPNewRequestFormValue;
  enablementType: EnablementType;
  principal: LawPersonSearch;
  authorizedPersonsToRegistryView: AuthorizedPersonToRegistryView[];
  mapState: MapState;
  selectedLegalPersonApplicant: LawPersonSearch;
  enablementLegalBasis?: string;
}

export const oneMegaByteInBytes = 1048576;
export const maxWorkspaceStateSizeInBytes = oneMegaByteInBytes * 30;
